export const CONFIG = {
    client_name : "schueco",
    client_display_name : "Schüco",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/schueco/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "12345",
    foerderung : true,
    development_mode: false,
}
